var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1752)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1752",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.896 31.4961H29.096",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.168 3.97198L22.23 4.11398L28.15 17.848H33.97C35.3171 17.8489 36.6502 18.1209 37.89 18.648L34.308 10.118L34.226 9.91798L34.084 9.59198C34.0491 9.47128 34.0015 9.35463 33.942 9.24398C31.274 3.04798 28.252 1.64798 22.168 3.97198Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.162 18.2639C12.0965 17.987 13.0674 17.8521 14.042 17.8639H28.152L22.236 4.11392L22.174 3.97192C21.868 4.07392 21.574 4.21792 21.276 4.33992L16.756 6.23792C14.7319 6.93524 12.9066 8.11207 11.436 9.66792C11.2409 9.89493 11.07 10.1416 10.926 10.4039C10.7478 10.674 10.6128 10.9702 10.526 11.2819C10.4497 11.453 10.3881 11.6304 10.342 11.8119C9.86082 13.9927 10.1506 16.2728 11.162 18.2639Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07202 27.8241V31.8061C4.07202 32.2061 4.09202 32.6221 4.11202 33.0321C4.50002 40.1581 8.48202 43.7521 16.036 43.7521H31.962C32.447 43.7493 32.9314 43.7153 33.412 43.6501C39.9054 43.2207 43.372 39.7541 43.812 33.2501C43.8772 32.7694 43.9113 32.2851 43.914 31.8001V27.8241C43.9109 25.8729 43.3369 23.9653 42.263 22.3363C41.1891 20.7072 39.662 19.428 37.87 18.6561C36.6297 18.1311 35.2969 17.8591 33.95 17.8561H14.016C13.0419 17.8514 12.072 17.9861 11.136 18.2561C9.09046 18.8863 7.30073 20.1555 6.02939 21.8775C4.75806 23.5995 4.07205 25.6836 4.07202 27.8241Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3159 10.1179L37.8899 18.6519C39.6815 19.4241 41.2082 20.7035 42.2817 22.3325C43.3553 23.9615 43.9289 25.869 43.9319 27.8199V21.8399C43.9339 19.0749 42.9764 16.3949 41.2228 14.2572C39.4691 12.1194 37.028 10.6565 34.3159 10.1179Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08008 21.838V27.82C4.07905 25.6831 4.76518 23.6024 6.03717 21.8853C7.30915 20.1682 9.09958 18.9056 11.1441 18.284C10.1434 16.2829 9.84275 14.0041 10.2901 11.812C10.3299 11.6286 10.3916 11.4506 10.4741 11.282C8.54436 12.2879 6.9277 13.8041 5.80025 15.6654C4.6728 17.5268 4.0778 19.6618 4.08008 21.838Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.6488b9f9da1c46db1b95de8c22cbe31b.svg";
export { ForwardRef as ReactComponent };